import React from "react";
import { useParams } from "react-router-dom";
import { useResetPassword } from "../../hooks/useResetPassword";
import ResetPasswordView from "./ResetPasswordView";

function ResetPasswordContainer() {
    const { token } = useParams();
    const resetPassword = useResetPassword(token);
    return <ResetPasswordView {...resetPassword} token={token} />;
}

export default ResetPasswordContainer;
